import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Typography } from '@nutrien/cxp-components';
import React from 'react';

interface Props {
  open: boolean;
  onClose: (val: boolean) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    deleteGrid: { padding: '25px 0px 25px 0px' },
    deleteText: { width: '100%', letterSpacing: '0.15px' },
  }),
);

const DiscardDraft: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog
      data-testid="cancel-confirmation-dialog"
      onClose={() => onClose(false)}
      open={open}
      titleText="Discard Changes"
      backButton={false}
      dialogActions={
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={5}>
            <Button
              data-testid="cc-cancel"
              onClick={() => onClose(false)}
              variant="outlined"
              color="primary"
              noMinHeight
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button
              data-testid="cc-yes"
              onClick={() => onClose(true)}
              variant="contained"
              color="error"
              noMinHeight
            >
              Yes, Discard
            </Button>
          </Grid>
        </Grid>
      }
      maxWidth="xs"
      noMinHeight
    >
      <Grid container className={classes.deleteGrid}>
        <Grid item container xs={12} alignItems="center">
          <Typography variant="h6" className={classes.deleteText}>
            Are you sure want to discard the changes?
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default DiscardDraft;
